import React, {useCallback, useEffect, useState} from "react";
import {AutoComplete, Button, Col, Form, Input, message, Modal, Row, Table} from "antd";
import {useHttp} from "../../hooks/http.hook";
import {notifyNetworkError} from "../../config/runtime";
import {withRouter} from "react-router";
import {Link} from "react-router-dom";
import DownloadLink from "react-download-link";
import {ExclamationCircleOutlined} from "@ant-design/icons";
import {ModalJsonFileInputButton} from "../Common/FileReader";

const OneView = ({editor, config, idx}) => {
    const [form] = Form.useForm({def: []})
    const [dataIn, setDataIn] = useState({});
    const {loading, request, error, clearError} = useHttp({def: {}});

    const fetchData = useCallback(async () => {
        try {
            const curr = idx ? await request(config.getOne.url({idx}), config.getOne.method) : {}
            form.setFieldsValue(curr)
            setDataIn(curr)
        } catch (e) {
            notifyNetworkError(message, `Ошибка сети: ${e.message}`)
        }
    }, [request, idx])

    useEffect( () => {
        fetchData().then(() => ({}))}, [idx]
    )

    const doFinish = (data) => {
        request(config.postOne.url({idx: idx || data[config.idx]}), config.postOne.method, {...dataIn, ...data}).then(data => console.log(data))
    }

    return <Form
        form={form}
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
        onFinish={doFinish}
    >
        {editor.map((item) =>
            <Form.Item name={item.key} label={item.title}>
                {
                    item.type == "textarea" ? <Input.TextArea/> :
                        item.type == "autocomplete" ? <AutoComplete options={item.getOptions({dataIn})}   filterOption={(inputValue, option) =>
                            option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                        }/> : <Input/>
                    }
            </Form.Item>)}
        <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
            <Button type="primary" htmlType="submit">
                Сохранить
            </Button>
        </Form.Item>
    </Form>
}

const OneViewButton = withRouter(({idx, key, location}) => <Button key={key}><Link to={`${location.pathname}/${idx}`}>Перейти</Link></Button>)

const DeleteButton = ({config, idx, rerender}) => {
    const {request} = useHttp({def: {}})
    const doDelete = (data) => {
        request(config.deleteOne.url({idx}), config.deleteOne.method).then(data => console.log(data))
        rerender()
    }
    return <Button onClick={() => Modal.confirm({
        icon: <ExclamationCircleOutlined/>,
        content: "Вы уверены что хотите удалить объект?",
        onOk() {
            doDelete(idx);
            console.log('try to delete');
        },
        onCancel() {
        },
    })}>Удалить</Button>
}

const actions = ({idx, customIdx, handleEditor, customActions, rerender}, config) => [
    {
        title: 'Действия',
        index: 'actions',
        key: "act",
        dataIndex: idx,
        render: (text, record) => {
            return <>
                <Button key={"edit"} type={"primary"} onClick={() => handleEditor(text)}>Редактировать</Button>
                <DeleteButton key={"del"} config={config} idx={text} rerender={rerender}/>
                <OneViewButton key="oneView" idx={text}/>
                {
                    customActions.map((action, i) => <Button key={`ca${i}`}><Link  to={action.href(text, record)}>{action.title}</Link></Button>)}
        </>}
    }
]

const TableView = withRouter(({ location, match, config, columns, editor, customActions}) => {
    const [open, setOpen] = useState(false)
    const [data, setData] = useState([]);
    const [render, setRender] = useState(0)
    const [itemToEdit, setItemToEdit] = useState('')
    const {loading, request, error, clearError} = useHttp({def: []});

    const handleCancel = () => setOpen(false)
    const handleOk = () => setOpen(false)
    const rerender = () => setRender(render => render + 1)

    const handleEditor = (idx) => {
        setItemToEdit(idx);
        setOpen(true);
    }

    const handleImport = (_data) => {
        const doSave = (data, idx) => {
            request(config.postOne.url({idx}), config.postOne.method, data).then(data => console.log(data))
        }
        _data.forEach( item => {
            //const elm = data.findIndex(i => i[config.idx] == data[config.idx])
            //elm === -1? tempData.push(item) : tempData[elm] = item
                doSave(item, item[config.idx])
            }
        )
        rerender()
    }

    const fetchData = useCallback(async () => {
        try {
            setData(await request(config.getAll.url, config.getAll.method))
        } catch (e) {
            notifyNetworkError(message, `Ошибка сети: ${e.message}`)
        }
    }, [request])

    useEffect( () => {
        fetchData()}, [render]
    )


    const cols = [
        ...columns,
        ...actions({idx: config.idx || '_id', handleEditor, customActions, rerender}, config),
    ]

    return <>
        <Row style={{width: "100%"}}>
            <Col span={12}>{config.title || ''}</Col>
            <Col span={12}>
                <Button key={"add"} style={{float: 'right', margins: 16}} type="primary" onClick={() => handleEditor('')}>Добавить</Button>
                <ModalJsonFileInputButton key={"import"} onImport={handleImport}/>
                <Button key="export" style={{float: 'right', margins: 16}}><DownloadLink tagName={'div'} label={"Экспорт"} style={{}} filename={'export.json'} exportFile={() => JSON.stringify(data)}>Экспорт</DownloadLink></Button>
            </Col>
        </Row>
        <Table
            columns={cols}
            dataSource={data}
            rowKey={config.idx}
        >
        </Table>
        <Modal title={"редактирование"} visible={open} onOk={handleOk} onCancel={handleCancel} width={"1000"}>
            (!) {itemToEdit}
            <OneView editor={editor} idx={itemToEdit} config={config}/>
        </Modal>
    </>
})


const ListView = withRouter(({match, ...other}) => {
    return match?.params?.cmd ? <OneView {...other} idx={match.params.cmd}/> : <TableView {...other} />
})


export default  ListView